import * as types from '../../mutation-types';
import dbConnector from '../../api/dbConnector';

const state = {
  all: []
}

const getters = {
  allSliders: state => state.all
}

const actions = {
  getAllSliders ({commit}, cb){
    dbConnector.getContentImageSlider(slides => {
      commit(types.RECEIVE_SLIDERS, {slides})
      if (cb) cb()
    })
  }
}

const mutations = {
  [types.RECEIVE_SLIDERS] (state, {slides}) {
    state.all = slides
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
